import styled from 'styled-components'

import { helpers } from 'styles'

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 0;
	background-color: ${helpers.color.primaryTranslucent};
	border: 1px solid ${helpers.color.primaryAccent};
	border-radius: 4px;
	width: 32px;
	height: 32px;
	color: ${helpers.color.primaryAccent};

	> svg {
		stroke-width: 1.6;
	}
`
